<template>

    <nav-bar :returnAction="true" :pageName="'Agendamentos'" @return="$router.push(`/patients`)"/>

    <main-container :onlyNav="true">
        
        <list-group class="py-2" v-if="schedulingStore.schedulings.length > 0">

            <list-item v-for="obj in schedulingStore.schedulings" :key="obj.id">
              <template v-slot:title>
                <h5 class="mb-1 fw-bold">{{ 'Consulta' }}</h5>                  
              </template>
              <template v-slot:complement>
                <p class="mb-0">{{`${formatSchedulingDate(obj.startDate)}`}}</p>   
                <p class="mb-0">{{`${formatSchedulingTime(obj.startDate, obj.endDate)}`}}</p>
              </template>
            </list-item>
        </list-group>

        <list-group class="py-2 list-group" v-else>
            <list-item class="list-group-item list-group-item-action">   
              <template v-slot:title>            
                <h5 class="mb-1 fw-bold">Nenhum Agendamento Encontrado!</h5>                        
              </template>            
            </list-item>         
        </list-group>


    </main-container>
</template>

<script>
import { useSchedulingStore } from '@/store/scheduling';
import {formatSchedulingDate, formatSchedulingTime} from "../../services/formatters";
export default {
    name:"PatientSchedulingsListView",
    inject:["mySpinner"],  
    setup() {
        const schedulingStore = useSchedulingStore();
        return { schedulingStore }
    },
    props: {
        patientId: {
            type:String,
            required: true
        }
    },
    async mounted() {
        this.mySpinner = true;
        this.schedulingStore.clear();
        await this.schedulingStore.getSchedulingsByUserId(this.patientId);
        this.schedulingStore.schedulings.sort((a, b) => (b.startDate > a.startDate) ? 1 : ((a.startDate > b.startDate) ? -1 : 0));
        this.mySpinner = false;
    },
    methods: {
        formatSchedulingTime,
        formatSchedulingDate
    }
}
</script>
